<template>
  <div class="main">
    <div class="row infos">
      <div class="col-xl-4 col-lg-12">
        <div class="blc-dados">
          <img src="/img/icon-grups.png" alt="icone porto" />
          <p>List of activities</p>
        </div>
      </div>
    </div>

    <div class="fundo">
      <div class="blc-inf-geral">
        <div class="blc-item">
          <div class="row align-items-center">
            <div class="col">
              <h2>List</h2>
            </div>
            <!-- <div class="col text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="$router.push('/usuarios/adicionar')"
              >
                <i class="fas fa-user-edit mr-2"></i>
                <span class="btn-inner--text">Adicionar Usuário</span>
              </base-button>
            </div> -->
          </div>
          <div class="row align-items-center mt-3">
            <div class="mrg-top-30 col-sl-3 col-lg-3 col-md-6 col-12">
              <base-input
                alternative=""
                label="Term"
                placeholder="search by term"
                input-classes="form-control-alternative"
                v-model.lazy="search.name"
              />
            </div>

            <div class="mrg-top-30 col-sl-1 col-lg-1 col-md-1 col-12">
              <button
                style="margin-top: 32px"
                class="submit w-100"
                value="Search"
                :disabled="loading"
                @click="listar()"
              >
                <i class="fa fa-spinner fa-spin" v-if="loading" /> Search
              </button>
            </div>
          </div>
        </div>
        <div class="blc-tabela scroll" style="overflow: visible">
          <table>
            <thead class="thead-light">
              <tr>
                <th>Activities</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="list">
              <tr v-for="(row, index) in list" :key="list.id">
                <td class="p-2">
                  {{ row.description }}
                </td>
                <td
                  v-if="row.action == 'editou'"
                  class="text-primary cursor-pointer"
                  @click="
                    $router.push({
                      name: 'Mostrar atividades usuário',
                      params: { id: row.id },
                    })
                  "
                >
                  <button class="submit">See Updates</button>
                </td>
                <td v-else></td>
              </tr>
              <tr v-if="!list.length && !loading">
                <td colspan="100" style="text-align: center">
                  No user activities found
                </td>
              </tr>
              <tr v-if="loading">
                <td colspan="100" style="text-align: center">
                  <i
                    class="fa fa-spinner fa-spin"
                    v-if="loading"
                    style="font-size: 20px"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <base-pagination
      :pagination="pagination"
      @change="listar()"
      align="center"
    ></base-pagination>
  </div>
</template>
<script>
  import Service from "@/services/UserLogs";
  export default {
    data() {
      return {
        Service,
        loading: false,
        pagination: {
          page: 1,
          last_page: 1,
          per_page: 20,
          total: 1,
        },
        search: {
          name: "",
        },
        orderBy: {
          campo: "FORNECEDOR",
          ordem: "asc",
        },
        list: [],
      };
    },
    created() {
      this.listar();
    },
    watch: {
      orderBy: {
        deep: true,
        handler() {
          this.pagination.page = 1;
          this.listar();
        },
      },
    },
    methods: {
      listar() {
        this.loading = true;
        this.list = [];
        Service.get({
          ...this.pagination,
          ...this.search,
        }).then((response) => {
          this.list = response.data.data;
          this.pagination.last_page = response.data.last_page;
          this.pagination.total = response.data.total;
          this.loading = false;
        });
      },
    },
  };
</script>
